// #region imports

// --- Angular
import { Component, OnInit } from '@angular/core';

// --- 3rd Party
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// #endregion

@Component({
  selector: 'hs-isbn-number-modal',
  templateUrl: './isbn-number-modal.component.html',
  styleUrls: ['./isbn-number-modal.component.scss']
})
export class IsbnNumberModalComponent {

  constructor(public activeModal: NgbActiveModal) { }

}
